// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kZc7","field":"styles_field__3SCUC","fieldCol":"styles_fieldCol__1zfqK","diffCol":"styles_diffCol__2Xp70","diff":"styles_diff__x4ss7"};